// var storage = window.localStorage;

export default function(result,storage){
    if(!result) return;
    console.log("loginCallback",result);
    let {token} = result;
    storage.setItem("token",token);
    this.$store.state.userInfo = result;
    // if(this.$route.path === "/initial"){
        
    // };
    if(this.$store.state.loginAfterRoute){
        this.$router.replace(this.$store.state.loginAfterRoute);
    }else{
        // this.$router.replace("/orderHistory");
        this.$router.replace("/");
    }
}

